import { useEffect, useState } from 'react';
import { Phone } from 'lucide-react';
import { HEADER } from '@/constants/testIds';

const NAV = [
	{ label: 'Services', href: '#services', id: HEADER.navServices },
	{ label: 'How It Works', href: '#how', id: HEADER.navHow },
	{ label: 'Coverage', href: '#coverage', id: HEADER.navCoverage },
	{ label: 'FAQ', href: '#faq', id: HEADER.navFaq },
];

export const Header = () => {
	const [scrolled, setScrolled] = useState(false);

	useEffect(() => {
		const onScroll = () => setScrolled(window.scrollY > 8);
		onScroll();
		window.addEventListener('scroll', onScroll, { passive: true });
		return () => window.removeEventListener('scroll', onScroll);
	}, []);

	return (
		<header
			data-testid={HEADER.root}
			className={`fixed top-0 left-0 right-0 z-50 bg-white border-b border-brand-navy transition-shadow ${
				scrolled ? 'shadow-[0_1px_0_0_#0D1B2A]' : ''
			}`}
		>
			<div className="mx-auto max-w-[1400px] px-4 sm:px-8 h-16 sm:h-20 flex items-center justify-between">
				<a
					href="#top"
					data-testid={HEADER.brand}
					className="flex items-center gap-2 sm:gap-3 group"
				>
					<span className="inline-block w-2.5 h-2.5 bg-brand-red pulse-dot" />
					<span className="font-anton text-xl sm:text-2xl tracking-tight text-brand-navy">
						Breakdown<span className="text-brand-red">experts</span>
					</span>
				</a>

				<nav className="hidden lg:flex items-center gap-8 text-[13px] font-chivo font-bold uppercase tracking-widest text-brand-navy">
					{NAV.map((n) => (
						<a
							key={n.label}
							href={n.href}
							data-testid={n.id}
							className="relative py-1 hover:text-brand-red transition-colors"
						>
							{n.label}
						</a>
					))}
				</nav>

				<a
					href="tel:+13072224082"
					data-testid={HEADER.callButton}
					className="btn-red !py-2.5 !px-3 sm:!px-5 text-[12px] sm:text-[15px]"
				>
					<Phone className="w-4 h-4 sm:w-5 sm:h-5" strokeWidth={2.5} />
					<span className="hidden sm:inline">
						Call (307) 222-4082
					</span>
					<span className="sm:hidden">Call Now</span>
				</a>
			</div>
		</header>
	);
};

export default Header;
